(function () {
    const Existing = customElements.get('star-rail-series-section');
  
    class StarRailSeriesSection extends HTMLElement {
      constructor() {
        super();
        this.__srCleanups = [];
      }
  
      connectedCallback() {
        if (this.__srInited) return;
        this.__srInited = true;
        this.classList.add('sr-js-ready');
        const run = (fn, label) => {
          try {
            fn();
          } catch (err) {
            console.error(`[star-rail-series] ${label}`, err);
          }
        };
        run(() => this.initCountdowns(), 'initCountdowns');
        run(() => this.initTimelines(), 'initTimelines');
        run(() => this.initIntros(), 'initIntros');
        run(() => this.initGiftboxes(), 'initGiftboxes');
        run(() => this.initPrizeGleam(), 'initPrizeGleam');
        run(() => this.initEventsCarousels(), 'initEventsCarousels');
        run(() => this.initPrizePortraitParallax(), 'initPrizePortraitParallax');
        run(() => this.initGoldDust(), 'initGoldDust');
        run(() => this.initEmailSubscribe(), 'initEmailSubscribe');
        run(() => this.initStickyTabbar(), 'initStickyTabbar');
      }
  
      disconnectedCallback() {
        this.clearCountdowns();
        this.runCleanups();
      }
  
      addCleanup(fn) {
        if (typeof fn === 'function') this.__srCleanups.push(fn);
      }
  
      runCleanups() {
        if (!Array.isArray(this.__srCleanups) || !this.__srCleanups.length) return;
        const cleanups = this.__srCleanups.splice(0);
        cleanups.forEach((fn) => {
          try {
            fn();
          } catch (_) {}
        });
      }
  
      clearCountdowns() {
        this.querySelectorAll('[data-sr-kv-countdown]').forEach((root) => {
          if (root.__srCountdownTimer) {
            window.clearInterval(root.__srCountdownTimer);
            delete root.__srCountdownTimer;
          }
        });
      }
  
      getSectionRoot() {
        return this.closest('.shopify-section') || this.parentElement || this;
      }
  
      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
  
      initGoldDust() {
        if (this.prefersReducedMotion()) return;
        this.querySelectorAll('[data-sr-gold-dust]').forEach((canvas) => {
          this.setupGoldDust(canvas);
        });
      }
  
      readTimelineCssPx(host, prop, fallback) {
        if (!host) return fallback;
        const raw = getComputedStyle(host).getPropertyValue(prop).trim();
        if (!raw) return fallback;
        const px = parseFloat(raw);
        if (Number.isFinite(px) && /px$/i.test(raw)) return px;
        const isHeight = prop.includes('height');
        const probe = document.createElement('div');
        probe.style.cssText = isHeight
          ? `position:absolute;visibility:hidden;pointer-events:none;height:${raw};width:0;`
          : `position:absolute;visibility:hidden;pointer-events:none;width:${raw};height:0;`;
        host.appendChild(probe);
        const measured = isHeight ? probe.getBoundingClientRect().height : probe.getBoundingClientRect().width;
        probe.remove();
        return measured > 0 ? measured : fallback;
      }
  
      getGoldDustPreset(canvas, host) {
        const zone =
          canvas?.dataset?.srGoldDustZone ||
          (host?.hasAttribute('data-sr-giftbox') ? 'giftbox' : host?.hasAttribute('data-sr-timeline') ? 'timeline' : 'timeline');
  
        const presets = {
          giftbox: {
            countMobile: 1200,
            countDesktop: 2700,
            rMin: 0.22,
            rRange: 0.48,
          },
          timeline: {
            countMobile: 780,
            countDesktop: 1750,
            rMin: 0.2,
            rRange: 0.45,
          },
          timelineGap: {
            countMobile: 420,
            countDesktop: 920,
            rMin: 0.18,
            rRange: 0.4,
          },
        };
  
        const density = presets[zone] || presets.timeline;
        const motion = {
          vxRange: 0.18,
          vyMin: 0.04,
          vyRange: 0.18,
          wobble: 0.03,
          phaseBase: 0.008,
          phaseTwinkle: 0.005,
        };
  
        return { zone, ...density, ...motion };
      }
  
      syncArcClipPath(canvas, host, arcBoundary, w, h) {
        const clipId = canvas?.dataset?.srArcClip;
        if (!clipId || !host || !arcBoundary || w <= 0 || h <= 0) return;
  
        const pathEl = host.querySelector(`#${clipId} [data-sr-arc-clip-path]`);
        if (!pathEl) return;
  
        const normY = (y) => Math.max(0, Math.min(1.35, y / h)).toFixed(4);
        const edge = normY(arcBoundary.edgeY);
        const control = normY(arcBoundary.controlY);
        pathEl.setAttribute(
          'd',
          `M 0,0 L 1,0 L 1,${edge} C 0.72,${control} 0.28,${control} 0,${edge} Z`
        );
      }
  
      syncGapArcClipPaths(host, gapBoundary, upperH, lowerH) {
        if (!host || !gapBoundary) return;
  
        const upperPath = host.querySelector('[data-sr-arc-clip-path="upper"]');
        const lowerPath = host.querySelector('[data-sr-arc-clip-path="lower"]');
        const bulge = gapBoundary.bulge;
        const gapH = gapBoundary.height;
  
        if (upperPath && upperH > 0) {
          const bite = Math.max(0, Math.min(0.42, bulge / upperH)).toFixed(4);
          const edge = (1 - parseFloat(bite)).toFixed(4);
          upperPath.setAttribute('d', `M 0,0 L 1,0 L 1,1 C 0.72,${edge} 0.28,${edge} 0,1 Z`);
        }
  
        if (lowerPath && lowerH > 0) {
          const bite = Math.max(0, Math.min(0.42, bulge / lowerH)).toFixed(4);
          lowerPath.setAttribute('d', `M 0,${bite} C 0.28,0 0.72,0 1,${bite} L 1,1 L 0,1 Z`);
        }
  
        if (gapH > 0) {
          const topEdge = (bulge / gapH).toFixed(4);
          const bottomEdge = (1 - bulge / gapH).toFixed(4);
          gapBoundary.topNorm = topEdge;
          gapBoundary.bottomNorm = bottomEdge;
        }
      }
  
      setupGoldDust(canvas) {
        if (!canvas || canvas.dataset.srGoldDustBound === '1') return;
        canvas.dataset.srGoldDustBound = '1';
  
        const host = canvas.closest('[data-sr-timeline], [data-sr-giftbox]');
        let preset = this.getGoldDustPreset(canvas, host);
        const arcMode = canvas.dataset.srGoldDustArc || 'single';
        if (preset.zone === 'timeline' && (arcMode === 'gap' || arcMode === 'layer')) {
          preset = {
            ...preset,
            countMobile: 520,
            countDesktop: 1100,
            rMin: 0.2,
            rRange: 0.45,
          };
        }
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
  
        let particles = [];
        let rafId = 0;
        let running = false;
        let isVisible = false;
        let width = 0;
        let height = 0;
        let lastFrame = 0;
        let resizeRaf = 0;
        let resizeObserver = null;
        let intersectionObserver = null;
        let arcEdgeLift = 0;
        let arcDepth = 0;
        let arcBoundary = null;
  
        const readCssMetric = (prop, fallback) => {
          if (!host) return fallback;
          const raw = getComputedStyle(host).getPropertyValue(prop).trim();
          const parsed = parseFloat(raw);
          if (Number.isFinite(parsed) && /px$/i.test(raw)) return parsed;
          if (
            prop === '--sr-timeline-top-upper-w' ||
            prop === '--sr-timeline-top-bg-height' ||
            prop === '--sr-timeline-gold-dust-height'
          ) {
            return this.readTimelineCssPx(host, prop, fallback);
          }
          return Number.isFinite(parsed) ? parsed : fallback;
        };
  
        const readHeight = () => {
          const attr = canvas.getAttribute('data-sr-gold-dust-height');
          if (attr) {
            const parsed = parseFloat(attr);
            if (Number.isFinite(parsed)) return parsed;
          }
          const layerParent = canvas.closest('.sr-timeline__top-compose');
          if (layerParent) {
            const dustH = readCssMetric('--sr-timeline-gold-dust-height', 0);
            if (dustH > 0) return dustH;
            if (layerParent.clientHeight > 0) return layerParent.clientHeight;
          }
          if (preset.zone === 'giftbox') {
            const hero = canvas.closest('.sr-giftbox__hero');
            const compose = canvas.closest('.sr-giftbox__hero-compose');
            const media = canvas.closest('.sr-giftbox__media');
            const mount = compose || media || hero;
            if (mount?.clientHeight > 0) return mount.clientHeight;
            if (hero?.clientHeight > 0) return hero.clientHeight;
            return this.readTimelineCssPx(host, '--sr-giftbox-hero-height', 1160);
          }
          if (host) {
            if (host.clientHeight > 0 && arcMode === 'layer') {
              return host.clientHeight;
            }
            return readCssMetric('--sr-timeline-top-bg-height', 350);
          }
          return 350;
        };
  
        const particleCount = () =>
          window.innerWidth <= 768 ? preset.countMobile : preset.countDesktop;
  
        const readArcMetric = (prop, fallback) => {
          if (!host) return fallback;
          const raw = getComputedStyle(host).getPropertyValue(prop).trim();
          const parsed = parseFloat(raw);
          return Number.isFinite(parsed) ? parsed : fallback;
        };
  
        const buildGapArcBoundary = (w, h, bulge) => {
          const p0x = 0;
          const p1x = w * 0.28;
          const p2x = w * 0.72;
          const p3x = w;
          const topP0y = 0;
          const topP1y = bulge;
          const topP2y = bulge;
          const topP3y = 0;
          const botP0y = h;
          const botP1y = h - bulge;
          const botP2y = h - bulge;
          const botP3y = h;
  
          const cubicAt = (t, a, b, c, d) => {
            const u = 1 - t;
            return u * u * u * a + 3 * u * u * t * b + 3 * u * t * t * c + t * t * t * d;
          };
  
          const curveYAt = (x, y0, y1, y2, y3) => {
            if (w <= 0) return y0;
            const clampedX = Math.max(0, Math.min(w, x));
            let lo = 0;
            let hi = 1;
            for (let i = 0; i < 16; i += 1) {
              const mid = (lo + hi) * 0.5;
              const bx = cubicAt(mid, p0x, p1x, p2x, p3x);
              if (bx < clampedX) lo = mid;
              else hi = mid;
            }
            const t = (lo + hi) * 0.5;
            return cubicAt(t, y0, y1, y2, y3);
          };
  
          const topYAt = (x) => curveYAt(x, topP0y, topP1y, topP2y, topP3y);
          const bottomYAt = (x) => curveYAt(x, botP0y, botP1y, botP2y, botP3y);
  
          return {
            height: h,
            bulge,
            topYAt,
            bottomYAt,
            isInside: (x, y) => y > topYAt(x) + 0.15 && y < bottomYAt(x) - 0.15,
            applyClip: (context) => {
              context.beginPath();
              context.moveTo(0, topP0y);
              context.bezierCurveTo(p1x, topP1y, p2x, topP2y, w, topP3y);
              context.lineTo(w, botP3y);
              context.bezierCurveTo(p2x, botP2y, p1x, botP1y, 0, botP0y);
              context.closePath();
              context.clip();
            },
          };
        };
  
        const buildArcBoundary = (w, h, edgeLift, depth) => {
          const edgeY = Math.max(0, h - edgeLift);
          const controlY = edgeY + depth;
          const p0x = 0;
          const p1x = w * 0.28;
          const p2x = w * 0.72;
          const p3x = w;
          const p0y = edgeY;
          const p1y = controlY;
          const p2y = controlY;
          const p3y = edgeY;
  
          const cubicAt = (t, a, b, c, d) => {
            const u = 1 - t;
            return u * u * u * a + 3 * u * u * t * b + 3 * u * t * t * c + t * t * t * d;
          };
  
          const arcMaxYAt = (x) => {
            if (w <= 0) return edgeY;
            const clampedX = Math.max(0, Math.min(w, x));
            let lo = 0;
            let hi = 1;
            for (let i = 0; i < 16; i += 1) {
              const mid = (lo + hi) * 0.5;
              const bx = cubicAt(mid, p0x, p1x, p2x, p3x);
              if (bx < clampedX) lo = mid;
              else hi = mid;
            }
            const t = (lo + hi) * 0.5;
            return cubicAt(t, p0y, p1y, p2y, p3y);
          };
  
          return {
            edgeY,
            controlY,
            arcMaxYAt,
            isInside: (x, y) => y >= 0 && y < arcMaxYAt(x) - 0.35,
            applyClip: (context) => {
              context.beginPath();
              context.moveTo(0, 0);
              context.lineTo(w, 0);
              context.lineTo(w, edgeY);
              context.bezierCurveTo(p2x, controlY, p1x, controlY, 0, edgeY);
              context.closePath();
              context.clip();
            },
          };
        };
  
        const randomPointInArc = () => {
          if (!arcBoundary) {
            return { x: Math.random() * width, y: Math.random() * height };
          }
          if (arcBoundary.topYAt && arcBoundary.bottomYAt) {
            for (let attempt = 0; attempt < 16; attempt += 1) {
              const x = Math.random() * width;
              const minY = arcBoundary.topYAt(x) + 0.5;
              const maxY = arcBoundary.bottomYAt(x) - 0.5;
              if (maxY <= minY) continue;
              const y = minY + Math.random() * (maxY - minY);
              if (arcBoundary.isInside(x, y)) return { x, y };
            }
            const fallbackX = width * 0.5;
            const mid =
              (arcBoundary.topYAt(fallbackX) + arcBoundary.bottomYAt(fallbackX)) * 0.5;
            return { x: fallbackX, y: mid };
          }
          for (let attempt = 0; attempt < 16; attempt += 1) {
            const x = Math.random() * width;
            const maxY = arcBoundary.arcMaxYAt(x) - 1;
            if (maxY <= 0) continue;
            const y = Math.random() * maxY;
            if (arcBoundary.isInside(x, y)) return { x, y };
          }
          const fallbackX = width * 0.5;
          return { x: fallbackX, y: arcBoundary.arcMaxYAt(fallbackX) * 0.42 };
        };
  
        const spawnParticle = () => {
          const warm = Math.random() > 0.35;
          const { x, y } = randomPointInArc();
          return {
            x,
            y,
            r: preset.rMin + Math.random() * preset.rRange,
            vx: (Math.random() - 0.5) * preset.vxRange,
            vy: preset.vyMin + Math.random() * preset.vyRange,
            phase: Math.random() * Math.PI * 2,
            twinkle: 0.35 + Math.random() * 0.65,
            warm,
          };
        };
  
        const resetParticles = () => {
          particles = Array.from({ length: particleCount() }, spawnParticle);
        };
  
        const resize = () => {
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          const layerParent = canvas.closest('.sr-timeline__top-compose');
          if (arcMode === 'layer' && layerParent) {
            width = Math.max(1, layerParent.clientWidth, canvas.clientWidth);
            height = Math.max(1, readHeight(), canvas.clientHeight);
          } else if (preset.zone === 'giftbox') {
            const hero = canvas.closest('.sr-giftbox__hero');
            const compose = canvas.closest('.sr-giftbox__hero-compose');
            const mount = compose || hero || canvas.parentElement;
            width = mount?.clientWidth > 0 ? mount.clientWidth : window.innerWidth;
            height = readHeight();
          } else {
            const parent = canvas.parentElement;
            width = parent && parent.clientWidth > 0 ? parent.clientWidth : window.innerWidth;
            height = readHeight();
          }
          if (preset.zone === 'timeline' && arcMode === 'gap') {
            const bulge = readCssMetric(
              '--sr-timeline-gold-dust-gap-bulge',
              Math.min(height * 0.46, readArcMetric('--sr-timeline-gold-dust-arc-depth', height * 0.4))
            );
            arcBoundary = buildGapArcBoundary(width, height, bulge);
            syncGapArcClipPaths(
              host,
              arcBoundary,
              readCssMetric('--sr-timeline-top-upper-h', height),
              readCssMetric('--sr-timeline-top-bg-height', height)
            );
          } else if (preset.zone === 'timeline' && arcMode === 'layer') {
            const bulge = readCssMetric(
              '--sr-timeline-gold-dust-gap-bulge',
              Math.min(height * 0.55, readArcMetric('--sr-timeline-gold-dust-arc-depth', height * 0.4))
            );
            arcBoundary = buildGapArcBoundary(width, height, bulge);
          } else if (preset.zone === 'timeline') {
            arcEdgeLift = readArcMetric('--sr-timeline-gold-dust-arc-edge-lift', height * 0.12);
            arcDepth = readArcMetric('--sr-timeline-gold-dust-arc-depth', height * 0.21);
            arcBoundary = buildArcBoundary(width, height, arcEdgeLift, arcDepth);
            syncArcClipPath(canvas, host, arcBoundary, width, height);
          } else if (preset.zone === 'giftbox') {
            arcEdgeLift = readArcMetric('--sr-giftbox-gold-dust-arc-edge-lift', height * 0.07);
            arcDepth = readArcMetric('--sr-giftbox-gold-dust-arc-depth', height * 0.17);
            arcBoundary = buildArcBoundary(width, height, arcEdgeLift, arcDepth);
            syncArcClipPath(canvas, host, arcBoundary, width, height);
          } else {
            arcEdgeLift = 0;
            arcDepth = 0;
            arcBoundary = null;
          }
          canvas.width = Math.max(1, Math.floor(width * dpr));
          canvas.height = Math.max(1, Math.floor(height * dpr));
          canvas.style.width = `${width}px`;
          canvas.style.height = `${height}px`;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          resetParticles();
        };
  
        const scheduleResize = () => {
          if (resizeRaf) return;
          resizeRaf = window.requestAnimationFrame(() => {
            resizeRaf = 0;
            resize();
          });
        };
  
        const drawParticle = (p) => {
          const boost =
            preset.zone === 'giftbox' || (preset.zone === 'timeline' && arcMode === 'layer') ? 1.28 : 1;
          const twinkle = 0.35 + (Math.sin(p.phase * 2.2) * 0.5 + 0.5) * 0.55 * p.twinkle;
          const alpha = Math.min(1, twinkle * boost);
          if (p.warm) {
            ctx.fillStyle = `rgba(249, 233, 169, ${alpha})`;
          } else {
            ctx.fillStyle = `rgba(255, 248, 222, ${alpha * 0.95})`;
          }
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fill();
  
          if (alpha > 0.8 && p.r > 0.5) {
            ctx.fillStyle = `rgba(255, 255, 255, ${(alpha - 0.55) * 0.35})`;
            ctx.beginPath();
            ctx.arc(p.x, p.y, p.r * 0.4, 0, Math.PI * 2);
            ctx.fill();
          }
        };
  
        const useDrawArcClip = !!arcBoundary && preset.zone === 'timeline';
  
        const applyDrawMask = () => {
          if (!useDrawArcClip) return;
          arcBoundary.applyClip(ctx);
        };
  
        const tick = (now) => {
          if (!running) return;
          rafId = window.requestAnimationFrame(tick);
          if (!now) return;
          if (!lastFrame) lastFrame = now;
          const delta = now - lastFrame;
          if (delta < 33) return;
          const velocityFactor = delta / 16.6667;
          lastFrame = now;
          ctx.clearRect(0, 0, width, height);
          ctx.save();
          applyDrawMask();
          for (let i = 0; i < particles.length; i += 1) {
            const p = particles[i];
            p.x += (p.vx + Math.sin(p.phase) * preset.wobble) * velocityFactor;
            p.y += p.vy * velocityFactor;
            p.phase += (preset.phaseBase + p.twinkle * preset.phaseTwinkle) * velocityFactor;
  
            if (useDrawArcClip && arcBoundary && !arcBoundary.isInside(p.x, p.y)) {
              const next = randomPointInArc();
              p.x = next.x;
              p.y = next.y;
            } else if (p.y > height + 2) {
              const next = randomPointInArc();
              p.y = next.y;
              p.x = next.x;
            }
            if (p.x < -2) p.x = width + 2;
            if (p.x > width + 2) p.x = -2;
  
            drawParticle(p);
          }
          ctx.restore();
        };
  
        const start = () => {
          if (running || document.hidden || !isVisible) return;
          running = true;
          lastFrame = 0;
          rafId = window.requestAnimationFrame(tick);
        };
  
        const stop = () => {
          running = false;
          window.cancelAnimationFrame(rafId);
          rafId = 0;
          lastFrame = 0;
          ctx.clearRect(0, 0, width, height);
        };
  
        const onVisibilityChange = () => {
          if (document.hidden) stop();
          else start();
        };
  
        resize();
  
        if (typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(scheduleResize);
          const layerCompose = canvas.closest('.sr-timeline__top-compose');
          if (layerCompose) resizeObserver.observe(layerCompose);
          else if (host) resizeObserver.observe(host);
        } else {
          window.addEventListener('resize', scheduleResize, { passive: true });
        }
  
        const visibilityTarget = canvas;
  
        const markVisibleAndStart = () => {
          isVisible = true;
          start();
        };
  
        if (typeof IntersectionObserver !== 'undefined') {
          intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                isVisible = entry.isIntersecting;
                if (entry.isIntersecting) start();
                else stop();
              });
            },
            { threshold: 0, rootMargin: '120px 0px' }
          );
          intersectionObserver.observe(visibilityTarget);
        } else {
          markVisibleAndStart();
        }
  
        const tryBootstrap = () => {
          resize();
          const rect = canvas.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) {
            markVisibleAndStart();
            return true;
          }
          return false;
        };
  
        requestAnimationFrame(() => {
          if (!tryBootstrap()) {
            requestAnimationFrame(() => {
              if (!tryBootstrap()) window.setTimeout(tryBootstrap, 120);
            });
          }
        });
  
        document.addEventListener('visibilitychange', onVisibilityChange, { passive: true });
  
        canvas.__srGoldDustCleanup = () => {
          stop();
          if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
          resizeObserver?.disconnect();
          intersectionObserver?.disconnect();
          window.removeEventListener('resize', scheduleResize);
          document.removeEventListener('visibilitychange', onVisibilityChange);
          delete canvas.dataset.srGoldDustBound;
          delete canvas.__srGoldDustCleanup;
        };
        this.addCleanup(canvas.__srGoldDustCleanup);
      }
  
      ensureGsap() {
        if (window.gsap && window.ScrollTrigger) {
          window.gsap.registerPlugin(window.ScrollTrigger);
          return Promise.resolve();
        }
  
        if (window.__srGsapPromise) return window.__srGsapPromise;
  
        const loadScript = (src, checkReady) =>
          new Promise((resolve, reject) => {
            if (typeof checkReady === 'function' && checkReady()) {
              resolve();
              return;
            }
            if (!src) {
              reject(new Error('missing script src'));
              return;
            }
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
              if (existing.dataset.loaded === '1' || (typeof checkReady === 'function' && checkReady())) {
                resolve();
                return;
              }
              existing.addEventListener('load', () => resolve(), { once: true });
              existing.addEventListener('error', () => reject(new Error(`failed ${src}`)), { once: true });
              return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            script.onload = () => {
              script.dataset.loaded = '1';
              resolve();
            };
            script.onerror = () => reject(new Error(`failed ${src}`));
            document.head.appendChild(script);
          });
  
        const gsapSrc = this.getAttribute('data-gsap-js');
        const stSrc = this.getAttribute('data-scroll-trigger-js');
  
        window.__srGsapPromise = Promise.all([
          loadScript(gsapSrc, () => !!window.gsap),
          loadScript(stSrc, () => !!window.ScrollTrigger),
        ])
          .then(() => {
            if (window.gsap && window.ScrollTrigger) {
              window.gsap.registerPlugin(window.ScrollTrigger);
            }
          })
          .catch(() => {});
  
        return window.__srGsapPromise;
      }
  
      mountPeekingCardParallax(card, opts = {}) {
        const gsap = window.gsap;
        const ScrollTrigger = window.ScrollTrigger;
        if (!gsap || !ScrollTrigger || !card) return null;
  
        const tracks = card.querySelectorAll('[data-parallax-track]');
        if (!tracks.length) return null;
  
        const scope = card.closest('.sr-prize__portrait') || card;
        const readNum = (el, key, fallback) => {
          const raw = el?.getAttribute(key);
          const n = raw !== null && raw !== '' ? Number(raw) : NaN;
          return Number.isFinite(n) ? n : fallback;
        };
  
        const getScale = () => {
          const fromData = readNum(card, 'data-img-scale', NaN);
          if (Number.isFinite(fromData)) return fromData;
          const cssScale = parseFloat(getComputedStyle(scope).getPropertyValue('--img-scale'));
          return Number.isFinite(cssScale) ? cssScale : 1.26;
        };
  
        const getMaxShift = () => {
          const viewH = card.offsetHeight || 610;
          return viewH * (getScale() - 1);
        };
  
        const scrollOpts = {
          trigger: opts.trigger || card,
          start: opts.start || 'top 90%',
          end: opts.end || 'top 22%',
          scrub: 0.95,
          invalidateOnRefresh: true,
        };
  
        const mm = gsap.matchMedia();
  
        mm.add('(min-width: 768px)', () => {
          const yStart = getMaxShift() + 48;
          const tl = gsap
            .timeline({ scrollTrigger: scrollOpts })
            .fromTo(
              tracks,
              { y: yStart },
              { y: yStart * 0.14, ease: 'none', duration: 0.8, immediateRender: false }
            )
            .to(tracks, { y: 0, ease: 'none', duration: 0.2 });
          return () => {
            tl.scrollTrigger?.kill();
            tl.kill();
          };
        });
  
        mm.add('(max-width: 767px)', () => {
          const tween = gsap.fromTo(
            tracks,
            { y: getMaxShift() + 28 },
            {
              y: 0,
              ease: 'none',
              immediateRender: false,
              scrollTrigger: scrollOpts,
            }
          );
          return () => {
            tween.scrollTrigger?.kill();
            tween.kill();
          };
        });
  
        card.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener(
            'load',
            () => {
              ScrollTrigger.refresh();
            },
            { once: true }
          );
        });
  
        ScrollTrigger.refresh();
        return mm;
      }
  
      initPrizePortraitParallax() {
        const sections = this.querySelectorAll('[data-sr-prize-parallax]');
        sections.forEach((section) => {
          this.setupPrizePortraitParallax(section);
        });
      }
  
      setupPrizePortraitParallax(section) {
        const card = section.querySelector('[data-peeking-card], [data-sr-peeking-card]');
        const portrait = section.querySelector('.sr-prize__portrait');
  
        if (!card) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
        const refresh = () => {
          if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        };
  
        const boot = () => {
          this.ensureGsap().then(() => {
            if (!window.gsap || !window.ScrollTrigger) return;
  
            if (section.__srPrizeParallaxCleanup) {
              section.__srPrizeParallaxCleanup();
            }
  
            const cleanups = [];
            let mmRevert = null;
            let mounted = false;
            let refreshRaf = 0;
  
            const mount = () => {
              if (mounted || !card.offsetHeight) return;
              mounted = true;
              mmRevert = this.mountPeekingCardParallax(card, {
                trigger: card,
                start: 'top 90%',
                end: 'top 22%',
              });
              section.dataset.srPrizeParallaxBound = '1';
              portrait?.classList.add('sr-prize__portrait--parallax-ready');
              refresh();
            };
  
            const waitImages = () =>
              Promise.all(
                Array.from(card.querySelectorAll('img')).map(
                  (img) =>
                    new Promise((resolve) => {
                      if (img.complete) {
                        resolve();
                        return;
                      }
                      img.addEventListener('load', resolve, { once: true });
                      img.addEventListener('error', resolve, { once: true });
                    })
                )
              );
  
            const tryMount = () => {
              window.requestAnimationFrame(() => {
                waitImages().then(mount);
              });
            };
  
            tryMount();
  
            const reveal = section.querySelector('.sr-prize__copy.sr-prize__reveal');
            if (reveal) {
              const onReveal = () => refresh();
              if (reveal.classList.contains('is-visible')) {
                onReveal();
              } else {
                const mo = new MutationObserver(() => {
                  if (!reveal.classList.contains('is-visible')) return;
                  onReveal();
                });
                mo.observe(reveal, { attributes: true, attributeFilter: ['class'] });
                cleanups.push(() => mo.disconnect());
              }
            }
  
            const onResize = () => {
              if (refreshRaf) return;
              refreshRaf = window.requestAnimationFrame(() => {
                refreshRaf = 0;
                refresh();
              });
            };
            window.addEventListener('resize', onResize, { passive: true });
            cleanups.push(() => window.removeEventListener('resize', onResize));
            tryMount();
            if (document.readyState === 'complete') {
              tryMount();
              refresh();
            } else {
              const onLoad = () => {
                tryMount();
                refresh();
              };
              window.addEventListener('load', onLoad, { once: true });
              cleanups.push(() => window.removeEventListener('load', onLoad));
            }
  
            section.__srPrizeParallaxCleanup = () => {
              mmRevert?.revert();
              mmRevert = null;
              if (refreshRaf) window.cancelAnimationFrame(refreshRaf);
              window.gsap?.set(card.querySelectorAll('[data-parallax-track]'), {
                clearProps: 'transform',
              });
              portrait?.classList.remove('sr-prize__portrait--parallax-ready');
              delete section.dataset.srPrizeParallaxBound;
              cleanups.forEach((fn) => fn());
              delete section.__srPrizeParallaxCleanup;
            };
            this.addCleanup(section.__srPrizeParallaxCleanup);
          });
        };
  
        boot();
      }
  
      extractTimezoneHour(offset) {
        if (!offset || offset === 'Z') return 0;
        const compact = String(offset).replace(/:/g, '');
        const match = compact.match(/^([+-])(\d{2})(\d{2})?$/);
        if (!match) return 0;
        const sign = match[1] === '+' ? 1 : -1;
        return sign * parseInt(match[2], 10);
      }
  
      parseTargetToUTC(dateStr, timezoneHour) {
        if (!dateStr) return NaN;
        const normalized = String(dateStr)
          .trim()
          .replace('T', ' ')
          .replace(/\//g, '-');
        const hasTime = normalized.includes(':');
        const fullStr = hasTime ? normalized : `${normalized} 00:00:00`;
        const sign = timezoneHour >= 0 ? '+' : '-';
        const absH = Math.abs(timezoneHour).toString().padStart(2, '0');
        const isoStr = `${fullStr.replace(' ', 'T')}${sign}${absH}:00`;
        const parsed = new Date(isoStr).getTime();
        if (!Number.isNaN(parsed)) return parsed;
        return new Date(fullStr.replace(' ', 'T')).getTime();
      }
  
      calcCountdownRemaining(endDate, locaTz, serverTime, serverTz) {
        const serverTimezoneHour = this.extractTimezoneHour(serverTz);
        const serverUTC = serverTime * 1000 - serverTimezoneHour * 3600 * 1000;
        const endUTC = this.parseTargetToUTC(endDate, locaTz);
        return Math.floor((endUTC - serverUTC) / 1000);
      }
  
      initCountdowns() {
        this.querySelectorAll('[data-sr-kv-countdown]').forEach((root) => {
          this.setupKvCountdown(root);
        });
      }
  
      setupKvCountdown(root) {
        if (!root || root.dataset.srKvCountdownBound === '1') return;
        root.dataset.srKvCountdownBound = '1';
  
        const endDate = root.getAttribute('data-end')?.trim();
        if (!endDate) return;
  
        const labels = (root.getAttribute('data-labels') || 'Days;;;Hrs;;;Mins;;;Secs').split(';;;');
        const locaTz = Number(root.getAttribute('data-timezone') || 8);
        const nowAttr = root.getAttribute('data-server-time');
        const serverTime =
          nowAttr !== null && nowAttr !== '' && !Number.isNaN(Number(nowAttr))
            ? Number(nowAttr)
            : Math.floor(Date.now() / 1000);
        const serverTz = root.getAttribute('data-server-tz') || '+0000';
  
        let remaining = this.calcCountdownRemaining(endDate, locaTz, serverTime, serverTz);
        if (!Number.isFinite(remaining)) return;
  
        const units = ['days', 'hours', 'minutes', 'seconds'];
        root.innerHTML = `<div class="ug-comp-countdown-div">${units
          .map((unit, i) => {
            const sep =
              i > 0 ? '<span class="ug-comp-countdown-sep" aria-hidden="true">:</span>' : '';
            return `${sep}<div class="ug-comp-countdown-item ug-comp-countdown-item-${unit}">
                <div class="ug-comp-countdown-item-box">
                  <span class="ug-comp-countdown-item-val countdown-${unit}">00</span>
                  <span class="ug-comp-countdown-item-test">${labels[i] || ''}</span>
                </div>
              </div>`;
          })
          .join('')}</div>`;
  
        const dayEl = root.querySelector('.countdown-days');
        const hourEl = root.querySelector('.countdown-hours');
        const minuteEl = root.querySelector('.countdown-minutes');
        const secondEl = root.querySelector('.countdown-seconds');
  
        const updateUI = (d, h, m, s) => {
          if (dayEl) dayEl.textContent = d;
          if (hourEl) hourEl.textContent = h;
          if (minuteEl) minuteEl.textContent = m;
          if (secondEl) secondEl.textContent = s;
        };
  
        const tick = () => {
          if (remaining <= 0) {
            updateUI('00', '00', '00', '00');
            root.classList.add('is-ended');
            return false;
          }
          updateUI(
            String(Math.floor(remaining / 86400)).padStart(2, '0'),
            String(Math.floor((remaining % 86400) / 3600)).padStart(2, '0'),
            String(Math.floor((remaining % 3600) / 60)).padStart(2, '0'),
            String(remaining % 60).padStart(2, '0')
          );
          return true;
        };
  
        if (!tick()) return;
  
        const timerId = setInterval(() => {
          remaining -= 1;
          if (!tick()) clearInterval(timerId);
        }, 1000);
        root.__srCountdownTimer = timerId;
        this.addCleanup(() => {
          if (root.__srCountdownTimer) {
            window.clearInterval(root.__srCountdownTimer);
            delete root.__srCountdownTimer;
          }
        });
      }
  
      initTimelines() {
        const timelines = this.querySelectorAll('[data-sr-timeline]');
        timelines.forEach((root) => this.setupTimeline(root));
      }
  
      initIntros() {
        const intros = this.querySelectorAll('[data-sr-intro]');
        intros.forEach((root) => this.setupIntro(root));
      }
  
      setupTimeline(root) {
        const reveals = root.querySelectorAll('.sr-timeline__reveal');
        const nodes = Array.from(root.querySelectorAll('.sr-timeline__node'));
        const slider = root.querySelector('[data-sr-timeline-slider]');
        const viewport = root.querySelector('.sr-timeline__viewport');
        const track = root.querySelector('.sr-timeline__track');
        const prevBtn = root.querySelector('.sr-timeline__cap-nav--prev');
        const nextBtn = root.querySelector('.sr-timeline__cap-nav--next');
        const rail = root.querySelector('[data-sr-timeline-rail]');
  
        this.applyMilestoneState(nodes, root);
        this.setupTimelineCarousel(root, slider, viewport, track, prevBtn, nextBtn, rail, nodes);
        this.observeReveal(reveals, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        this.observeReveal(
          nodes,
          { threshold: 0.35, rootMargin: '0px 0px -10% 0px' },
          'is-reached'
        );
      }
  
      setupTimelineCarousel(root, slider, viewport, track, prevBtn, nextBtn, rail, nodes) {
        if (!slider || !viewport || !track || !nodes.length) return;
  
        const maxVisible = parseInt(slider.dataset.maxVisible || '5', 10);
        const board = root.querySelector('.sr-timeline__board');
        const timelineMq = window.matchMedia('(max-width: 768px)');
        let index = 0;
        let layoutRaf = 0;
  
        const isMobileTimeline = () => timelineMq.matches;
  
        const updateLayout = () => {
          const isCarousel = nodes.length > maxVisible;
          if (board) {
            board.classList.toggle('sr-timeline__board--carousel', isCarousel && !isMobileTimeline());
          }
          if (rail) {
            rail.classList.toggle('sr-timeline__rail--carousel', isCarousel && !isMobileTimeline());
            rail.setAttribute('aria-hidden', isCarousel && !isMobileTimeline() ? 'false' : 'true');
          }
  
          nodes.forEach((node) => {
            node.style.flex = '';
            node.style.width = '';
            node.style.minWidth = '';
          });
          track.style.width = '';
          track.style.transform = '';
  
          if (isMobileTimeline()) {
            if (prevBtn) prevBtn.setAttribute('hidden', '');
            if (nextBtn) nextBtn.setAttribute('hidden', '');
            rail?.querySelector('.sr-timeline__rail-cap--start')?.classList.remove('sr-timeline__rail-cap--arrow');
            rail?.querySelector('.sr-timeline__rail-cap--end')?.classList.remove('sr-timeline__rail-cap--arrow');
            root.classList.add('sr-timeline--mb-stack');
            this.syncMobileTimelineRail(root, track);
            return;
          }
  
          root.style.removeProperty('--sr-timeline-mb-line-progress');
  
          root.classList.remove('sr-timeline--mb-stack');
  
          if (!isCarousel) {
            if (prevBtn) prevBtn.setAttribute('hidden', '');
            if (nextBtn) nextBtn.setAttribute('hidden', '');
            return;
          }
  
          const viewportWidth = viewport.clientWidth;
          const nodeWidth = viewportWidth / maxVisible;
          const maxIndex = Math.max(0, nodes.length - maxVisible);
  
          index = Math.max(0, Math.min(index, maxIndex));
  
          nodes.forEach((node) => {
            node.style.flex = `0 0 ${nodeWidth}px`;
            node.style.width = `${nodeWidth}px`;
            node.style.minWidth = `${nodeWidth}px`;
          });
  
          track.style.width = `${nodeWidth * nodes.length}px`;
          track.style.transform = `translate3d(-${index * nodeWidth}px, 0, 0)`;
  
          const startCap = rail?.querySelector('.sr-timeline__rail-cap--start');
          const endCap = rail?.querySelector('.sr-timeline__rail-cap--end');
  
          if (index <= 0) {
            if (prevBtn) prevBtn.setAttribute('hidden', '');
            startCap?.classList.remove('sr-timeline__rail-cap--arrow');
          } else {
            if (prevBtn) prevBtn.removeAttribute('hidden');
            startCap?.classList.add('sr-timeline__rail-cap--arrow');
          }
  
          if (index >= maxIndex) {
            if (nextBtn) nextBtn.setAttribute('hidden', '');
            endCap?.classList.remove('sr-timeline__rail-cap--arrow');
          } else {
            if (nextBtn) nextBtn.removeAttribute('hidden');
            endCap?.classList.add('sr-timeline__rail-cap--arrow');
          }
        };
  
        const scheduleLayout = () => {
          if (layoutRaf) return;
          layoutRaf = window.requestAnimationFrame(() => {
            layoutRaf = 0;
            updateLayout();
          });
        };
  
        if (prevBtn && !prevBtn.dataset.srBound) {
          prevBtn.dataset.srBound = '1';
          prevBtn.addEventListener('click', () => {
            index -= 1;
            scheduleLayout();
          });
        }
  
        if (nextBtn && !nextBtn.dataset.srBound) {
          nextBtn.dataset.srBound = '1';
          nextBtn.addEventListener('click', () => {
            index += 1;
            scheduleLayout();
          });
        }
  
        if (root.dataset.srTimelineResizeBound !== '1') {
          root.dataset.srTimelineResizeBound = '1';
          window.addEventListener('resize', scheduleLayout, { passive: true });
          if (typeof timelineMq.addEventListener === 'function') {
            timelineMq.addEventListener('change', scheduleLayout);
          } else if (typeof timelineMq.addListener === 'function') {
            timelineMq.addListener(scheduleLayout);
          }
          root.__srTimelineCleanup = () => {
            if (layoutRaf) window.cancelAnimationFrame(layoutRaf);
            window.removeEventListener('resize', scheduleLayout);
            if (typeof timelineMq.removeEventListener === 'function') {
              timelineMq.removeEventListener('change', scheduleLayout);
            } else if (typeof timelineMq.removeListener === 'function') {
              timelineMq.removeListener(scheduleLayout);
            }
            delete root.dataset.srTimelineResizeBound;
            delete root.__srTimelineCleanup;
          };
          this.addCleanup(root.__srTimelineCleanup);
        }
  
        if (root.dataset.srTimelineMbRailObsBound !== '1' && typeof ResizeObserver !== 'undefined') {
          root.dataset.srTimelineMbRailObsBound = '1';
          const railObserver = new ResizeObserver(() => {
            if (!isMobileTimeline()) return;
            this.syncMobileTimelineRail(root, track);
          });
          railObserver.observe(track);
          root.__srTimelineMbRailObsCleanup = () => {
            railObserver.disconnect();
            delete root.dataset.srTimelineMbRailObsBound;
            delete root.__srTimelineMbRailObsCleanup;
          };
          this.addCleanup(root.__srTimelineMbRailObsCleanup);
        }
  
        updateLayout();
      }
  
      initGiftboxes() {
        const blocks = this.querySelectorAll('[data-sr-giftbox]');
        blocks.forEach((root) => this.setupGiftbox(root));
      }
  
      initPrizeGleam() {
        const buttons = Array.from(this.getSectionRoot().querySelectorAll('[data-sr-gleam-open]')).filter(
          (btn) => !btn.closest('[data-sr-tabbar]')
        );
        const popups = Array.from(this.querySelectorAll('[data-sr-gleam-popup]'));
        if (!buttons.length && !popups.length) return;
  
        const ensureGleamScript = () => {
          if (window.__srGleamScriptPromise) return window.__srGleamScriptPromise;
  
          const existing = document.querySelector('script[data-sr-gleam-loader]');
          if (existing) {
            window.__srGleamScriptPromise = new Promise((resolve) => {
              if (existing.dataset.loaded === '1') {
                resolve();
                return;
              }
              existing.addEventListener('load', () => resolve(), { once: true });
              existing.addEventListener('error', () => resolve(), { once: true });
            });
            return window.__srGleamScriptPromise;
          }
  
          window.__srGleamScriptPromise = new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://widget.gleamjs.io/e.js';
            script.async = true;
            script.dataset.srGleamLoader = 'true';
            script.onload = () => {
              script.dataset.loaded = '1';
              resolve();
            };
            script.onerror = () => resolve();
            document.head.appendChild(script);
          });
  
          return window.__srGleamScriptPromise;
        };
  
        const getSectionScope = () => this.getSectionRoot() || document;
  
        const getPopupById = (gleamId) => {
          if (!gleamId) return null;
          const escapedId =
            window.CSS && typeof window.CSS.escape === 'function'
              ? window.CSS.escape(String(gleamId))
              : String(gleamId).replace(/"/g, '\\"');
          const selector = `[data-sr-gleam-popup="${escapedId}"]`;
          return this.querySelector(selector) || getSectionScope().querySelector(selector);
        };
  
        const closePopup = (popup) => {
          if (!(popup instanceof HTMLElement)) return;
          popup.setAttribute('hidden', '');
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        };
  
        const openPopup = async (popup) => {
          if (!(popup instanceof HTMLElement)) return;
          popup.removeAttribute('hidden');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
  
          await ensureGleamScript();
          window.dispatchEvent(new Event('resize'));
        };
  
        buttons.forEach((btn) => {
          if (btn.dataset.srGleamBound === '1') return;
          btn.dataset.srGleamBound = '1';
          const onClick = (event) => {
            event.preventDefault();
            const popup = getPopupById(btn.dataset.srGleamId);
            if (popup) {
              openPopup(popup);
              return;
            }
            const href = btn.dataset.gleamHref?.trim();
            if (href) window.open(href, '_blank', 'noopener,noreferrer');
          };
          btn.addEventListener('click', onClick);
          this.addCleanup(() => {
            btn.removeEventListener('click', onClick);
            delete btn.dataset.srGleamBound;
          });
        });
  
        popups.forEach((popup) => {
          if (popup.dataset.srGleamPopupBound === '1') return;
          popup.dataset.srGleamPopupBound = '1';
  
          const closeControls = popup.querySelectorAll('[data-sr-gleam-close]');
          const closeHandlers = [];
          const onKeydown = (event) => {
            if (event.key === 'Escape') closePopup(popup);
          };
  
          closeControls.forEach((el) => {
            const onCloseClick = () => closePopup(popup);
            closeHandlers.push([el, onCloseClick]);
            el.addEventListener('click', onCloseClick);
          });
          document.addEventListener('keydown', onKeydown);
  
          this.addCleanup(() => {
            closeHandlers.forEach(([el, handler]) => {
              el.removeEventListener('click', handler);
            });
            document.removeEventListener('keydown', onKeydown);
            closePopup(popup);
            delete popup.dataset.srGleamPopupBound;
          });
        });
      }
  
      getSrGleamPopupById(gleamId) {
        if (!gleamId) return null;
        const escapedId =
          window.CSS && typeof window.CSS.escape === 'function'
            ? window.CSS.escape(String(gleamId))
            : String(gleamId).replace(/"/g, '\\"');
        const selector = `[data-sr-gleam-popup="${escapedId}"]`;
        const scope = this.getSectionRoot() || document;
        return this.querySelector(selector) || scope.querySelector(selector);
      }
  
      ensureSrGleamScriptLoaded() {
        if (window.__srGleamScriptPromise) return window.__srGleamScriptPromise;
  
        const existing = document.querySelector('script[data-sr-gleam-loader]');
        if (existing) {
          window.__srGleamScriptPromise = new Promise((resolve) => {
            if (existing.dataset.loaded === '1') {
              resolve();
              return;
            }
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => resolve(), { once: true });
          });
          return window.__srGleamScriptPromise;
        }
  
        window.__srGleamScriptPromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://widget.gleamjs.io/e.js';
          script.async = true;
          script.dataset.srGleamLoader = 'true';
          script.onload = () => {
            script.dataset.loaded = '1';
            resolve();
          };
          script.onerror = () => resolve();
          document.head.appendChild(script);
        });
  
        return window.__srGleamScriptPromise;
      }
  
      closeSrGleamPopup(popup) {
        if (!(popup instanceof HTMLElement)) return;
        popup.setAttribute('hidden', '');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
  
      async openSrGleamPopup(popup) {
        if (!(popup instanceof HTMLElement)) return;
        popup.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        await this.ensureSrGleamScriptLoaded();
        window.dispatchEvent(new Event('resize'));
      }
  
      initEventsCarousels() {
        const carousels = this.querySelectorAll('[data-sr-events]');
        carousels.forEach((root) => this.setupEventsCarousel(root));
      }
  
      setupEventsCarousel(root) {
        const swiperEl = root.querySelector('[data-sr-events-swiper]');
        const dotsWrap = root.querySelector('[data-sr-events-dots]');
        const prevBtn = root.querySelector('[data-sr-events-prev]');
        const nextBtn = root.querySelector('[data-sr-events-next]');
  
        if (!swiperEl || swiperEl.dataset.srEventsSwiperBound === '1') return;
  
        const slides = Array.from(swiperEl.querySelectorAll('[data-sr-events-slide]'));
        if (slides.length === 0) return;
  
        const reducedMotion = this.prefersReducedMotion();
        const loop = slides.length > 1;
  
        const syncDots = (realIndex) => {
          if (!dotsWrap) return;
          dotsWrap.querySelectorAll('.sr-events__dot').forEach((dot, i) => {
            const active = i === realIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          slides.forEach((slide, i) => {
            slide.setAttribute('aria-hidden', i === realIndex ? 'false' : 'true');
          });
        };
  
        const bindDot = (dot, i, swiper) => {
          if (dot.dataset.srEventsDotBound === '1') return;
          dot.dataset.srEventsDotBound = '1';
          dot.type = 'button';
          dot.className = 'sr-events__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Slide ${i + 1}`);
          dot.addEventListener('click', () => {
            if (swiper.params.loop) swiper.slideToLoop(i);
            else swiper.slideTo(i);
          });
        };
  
        const buildDots = (swiper) => {
          if (!dotsWrap || slides.length < 2) return;
  
          const existing = Array.from(dotsWrap.querySelectorAll('.sr-events__dot'));
          if (existing.length === slides.length) {
            existing.forEach((dot, i) => bindDot(dot, i, swiper));
            syncDots(swiper.realIndex);
            return;
          }
  
          dotsWrap.innerHTML = '';
          slides.forEach((_, i) => {
            const dot = document.createElement('button');
            bindDot(dot, i, swiper);
            dotsWrap.appendChild(dot);
          });
        };
  
        const eventsMbMq = window.matchMedia('(max-width: 768px)');
        let mountToken = 0;
  
        const isEventsMobile = () => eventsMbMq.matches;
  
        const setEventsLayoutMode = () => {
          root.dataset.srEventsLayout = isEventsMobile() ? 'mb' : 'pc';
        };
  
        const getEventsSwiperOptions = () => {
          const shared = {
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            loop,
            loopedSlides: slides.length,
            speed: 650,
            slideToClickedSlide: loop,
            watchSlidesProgress: true,
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
            autoplay:
              loop && !reducedMotion
                ? {
                    delay: 4500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
                : false,
            on: {
              init(s) {
                buildDots(s);
                syncDots(s.realIndex);
              },
              slideChange(s) {
                syncDots(s.realIndex);
              },
            },
          };
  
          if (isEventsMobile()) {
            return {
              ...shared,
              effect: 'slide',
              spaceBetween: 0,
            };
          }
  
          return {
            ...shared,
            effect: 'coverflow',
            spaceBetween: 0,
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            },
          };
        };
  
        const destroyEventsSwiper = () => {
          const existing = swiperEl.__srEventsSwiper;
          if (existing && typeof existing.destroy === 'function') {
            existing.destroy(true, true);
          }
          swiperEl.__srEventsSwiper = null;
          delete swiperEl.dataset.srEventsSwiperBound;
        };
  
        const mountSwiper = async () => {
          const token = ++mountToken;
          const SwiperCtor = await this.ensureSwiper();
          if (!SwiperCtor || token !== mountToken) return;
          destroyEventsSwiper();
          setEventsLayoutMode();
          swiperEl.dataset.srEventsSwiperBound = '1';
  
          const swiper = new SwiperCtor(swiperEl, getEventsSwiperOptions());
          swiperEl.__srEventsSwiper = swiper;
        };
  
        mountSwiper();
  
        if (!root.dataset.srEventsResizeBound) {
          root.dataset.srEventsResizeBound = '1';
          let layoutMode = root.dataset.srEventsLayout;
  
          const onLayoutChange = () => {
            const nextMode = isEventsMobile() ? 'mb' : 'pc';
            if (nextMode !== layoutMode) {
              layoutMode = nextMode;
              mountSwiper();
              return;
            }
            const swiper = swiperEl.__srEventsSwiper;
            if (swiper) swiper.update();
          };
  
          window.addEventListener('resize', onLayoutChange, { passive: true });
          if (typeof eventsMbMq.addEventListener === 'function') {
            eventsMbMq.addEventListener('change', onLayoutChange);
          } else if (typeof eventsMbMq.addListener === 'function') {
            eventsMbMq.addListener(onLayoutChange);
          }
          root.__srEventsCleanup = () => {
            mountToken += 1;
            destroyEventsSwiper();
            window.removeEventListener('resize', onLayoutChange);
            if (typeof eventsMbMq.removeEventListener === 'function') {
              eventsMbMq.removeEventListener('change', onLayoutChange);
            } else if (typeof eventsMbMq.removeListener === 'function') {
              eventsMbMq.removeListener(onLayoutChange);
            }
            delete root.dataset.srEventsResizeBound;
            delete root.__srEventsCleanup;
          };
          this.addCleanup(root.__srEventsCleanup);
        }
      }
  
      ensureSwiper() {
        if (window.Swiper) return Promise.resolve(window.Swiper);
        if (window.__srSwiperPromise) return window.__srSwiperPromise;
  
        window.__srSwiperPromise = new Promise((resolve) => {
          const existing = document.querySelector('script[src*="swiper"]');
          if (!existing) {
            resolve(window.Swiper || null);
            return;
          }
          if (window.Swiper) {
            resolve(window.Swiper);
            return;
          }
          existing.addEventListener('load', () => resolve(window.Swiper || null), { once: true });
          existing.addEventListener('error', () => resolve(null), { once: true });
        });
  
        return window.__srSwiperPromise;
      }
  
      setupGiftbox(root) {
        const textEls = root.querySelectorAll('.sr-giftbox__reveal--text');
        const prizeReveal = root.querySelector('.sr-prize__reveal');
        const eventsReveal = root.querySelector('.sr-events__reveal');
  
        if (typeof IntersectionObserver === 'undefined') {
          textEls.forEach((el) => el.classList.add('is-visible'));
          if (prizeReveal) prizeReveal.classList.add('is-visible');
          if (eventsReveal) eventsReveal.classList.add('is-visible');
          this.bindGiftboxTextFloat(root);
          if (window.ScrollTrigger) window.ScrollTrigger.refresh();
          return;
        }
  
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              root.classList.add('is-animated');
              textEls.forEach((el) => el.classList.add('is-visible'));
              this.bindGiftboxTextFloat(root);
              if (prizeReveal) {
                window.setTimeout(() => {
                  prizeReveal.classList.add('is-visible');
                  if (window.ScrollTrigger) window.ScrollTrigger.refresh();
                }, 280);
              }
              if (eventsReveal) {
                window.setTimeout(() => {
                  eventsReveal.classList.add('is-visible');
                  this.querySelectorAll('[data-sr-events-swiper]').forEach((el) => {
                    if (el.__srEventsSwiper) el.__srEventsSwiper.update();
                  });
                }, 420);
              }
              observer.unobserve(root);
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
        );
  
        observer.observe(root);
        root.__srGiftboxCleanup = () => {
          observer.disconnect();
          delete root.__srGiftboxCleanup;
        };
        this.addCleanup(root.__srGiftboxCleanup);
      }
  
      bindGiftboxTextFloat(root) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
        const copy = root.querySelector('.sr-giftbox__copy');
        if (!copy) return;
        if (root.dataset.srGiftboxTextFloatBound === '1') return;
        root.dataset.srGiftboxTextFloatBound = '1';
        let rafId = 0;
  
        const update = () => {
          const rect = root.getBoundingClientRect();
          const vh = window.innerHeight || 1;
          if (rect.bottom < 0 || rect.top > vh) return;
          const progress = (vh - rect.top) / (vh + rect.height * 0.65);
          const offset = Math.max(-56, Math.min(0, (0.35 - progress) * 80));
          copy.style.setProperty('--sr-giftbox-text-float', `${offset}px`);
        };
  
        const scheduleUpdate = () => {
          if (rafId) return;
          rafId = window.requestAnimationFrame(() => {
            rafId = 0;
            update();
          });
        };
  
        update();
        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate, { passive: true });
        root.__srGiftboxTextFloatCleanup = () => {
          if (rafId) window.cancelAnimationFrame(rafId);
          window.removeEventListener('scroll', scheduleUpdate);
          window.removeEventListener('resize', scheduleUpdate);
          delete root.dataset.srGiftboxTextFloatBound;
          delete root.__srGiftboxTextFloatCleanup;
        };
        this.addCleanup(root.__srGiftboxTextFloatCleanup);
      }
  
      setupIntro(root) {
        const media = root.querySelector('.sr-intro__reveal--media');
        const text = root.querySelector('.sr-intro__reveal--text');
        const targets = [media, text].filter(Boolean);
  
        if (typeof IntersectionObserver === 'undefined') {
          targets.forEach((el) => el.classList.add('is-visible'));
          return;
        }
  
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const el = entry.target;
              if (el.classList.contains('sr-intro__reveal--text')) {
                window.setTimeout(() => el.classList.add('is-visible'), 180);
              } else {
                el.classList.add('is-visible');
              }
              observer.unobserve(el);
            });
          },
          { root: null, threshold: 0.18, rootMargin: '0px 0px -6% 0px' }
        );
  
        targets.forEach((el) => observer.observe(el));
        root.__srIntroCleanup = () => {
          observer.disconnect();
          delete root.__srIntroCleanup;
        };
        this.addCleanup(root.__srIntroCleanup);
      }
  
      parseMilestone(value) {
        if (!value) return null;
        const match = value
          .trim()
          .match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?/);
        if (!match) return null;
  
        const y = Number(match[1]);
        const m = Number(match[2]);
        const d = Number(match[3]);
        const h = match[4] === undefined ? 0 : Number(match[4]);
        const min = match[5] === undefined ? 0 : Number(match[5]);
        const s = match[6] === undefined ? 0 : Number(match[6]);
        if ([y, m, d, h, min, s].some((part) => Number.isNaN(part))) return null;
  
        const date = new Date(y, m - 1, d, h, min, s);
        if (Number.isNaN(date.getTime())) return null;
  
        const key = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
        return { y, m, d, key, time: date.getTime() };
      }
  
      getTimelineTodayKey() {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      }
  
      applyMilestoneState(nodes, root) {
        const todayKey = this.getTimelineTodayKey();
        const nowTime = Date.now();
        let latestReachedTime = 0;
        let latestReachedNode = null;
  
        nodes.forEach((node) => {
          const milestone = this.parseMilestone(node.dataset.milestone);
          node.classList.remove('is-past', 'is-active', 'is-reached', 'is-today');
          if (!milestone) return;
          /* 已过当前时间的里程碑高亮；未到期保持默认半透明 */
          if (milestone.time <= nowTime) {
            node.classList.add('is-past', 'is-active');
            if (milestone.key === todayKey) {
              node.classList.add('is-today');
            }
            if (!latestReachedTime || milestone.time > latestReachedTime) {
              latestReachedTime = milestone.time;
              latestReachedNode = node;
            }
          }
        });
  
        if (root && window.matchMedia('(max-width: 768px)').matches) {
          const track = root.querySelector('.sr-timeline__track');
          this.syncMobileTimelineRail(root, track, latestReachedNode);
        }
      }
  
      syncMobileTimelineRail(root, track, highlightNode) {
        if (!root || !track) return;
        const rail = root.querySelector('[data-sr-timeline-rail]');
        const line = rail?.querySelector('.sr-timeline__line');
        if (!line) return;
  
        const node =
          highlightNode instanceof HTMLElement
            ? highlightNode
            : root.querySelector('.sr-timeline__node.is-today') ||
              Array.from(root.querySelectorAll('.sr-timeline__node.is-past')).pop();
        const iconWrap = node?.querySelector('.sr-timeline__icon-wrap');
  
        if (!iconWrap) {
          root.style.removeProperty('--sr-timeline-mb-line-progress');
          return;
        }
  
        const trackRect = track.getBoundingClientRect();
        const iconRect = iconWrap.getBoundingClientRect();
        const progress = iconRect.top + iconRect.height / 2 - trackRect.top;
  
        root.style.setProperty(
          '--sr-timeline-mb-line-progress',
          `${Math.max(0, Math.round(progress))}px`
        );
      }
  
      initStickyTabbar() {
        const tabbar = this.getSectionRoot()?.querySelector('[data-sr-tabbar]');
        if (!tabbar || tabbar.dataset.srTabbarDockBound === '1') return;
        tabbar.dataset.srTabbarDockBound = '1';

        const cursorUrl = this.getAttribute('data-sr-cursor') || '';
        if (cursorUrl) {
          this.style.setProperty('--sr-custom-cursor', `url("${cursorUrl}") 16 16, auto`);
        }

        const kv = this.querySelector('.sr-kv');
        const cta = tabbar.querySelector('.sr-tabbar__cta');
        let footerEl = null;
        let footerResizeObserver = null;
        let barResizeObserver = null;
        const getFooterEl = () => {
          if (footerEl && document.documentElement.contains(footerEl)) return footerEl;
          footerEl =
            document.querySelector('footer') ||
            document.querySelector('#shopify-section-footer') ||
            document.querySelector('.t4s-footer');
          return footerEl;
        };
  
        let ticking = false;
        let rafId = 0;
        let lastMode = '';
        let lastTop = -1;
        let lastVisibleState = null;
  
        const setVisibleState = (visible) => {
          if (lastVisibleState === visible) return;
          lastVisibleState = visible;
          tabbar.classList.toggle('is-visible', visible);
        };
  
        const updateStickyBarPosition = () => {
          const footer = getFooterEl();
          const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0;
          const kvRect = kv?.getBoundingClientRect();
          const kvBannerScrolledPast = !kv || (kvRect && kvRect.bottom <= 0);

          setVisibleState(kvBannerScrolledPast);
  
          if (!footer) {
            if (lastMode !== 'fixed') {
              lastMode = 'fixed';
              lastTop = -1;
              tabbar.style.position = 'fixed';
              tabbar.style.top = 'auto';
              tabbar.style.bottom = '0';
              tabbar.style.left = '0';
              tabbar.style.right = '0';
              tabbar.style.transform = '';
            }
            ticking = false;
            rafId = 0;
            return;
          }
  
          const footerRect = footer.getBoundingClientRect();
          const footerPageTop = footerRect.top + window.pageYOffset;
          const viewportBottom = window.pageYOffset + viewportHeight;
          const barHeight = Math.ceil(tabbar.getBoundingClientRect().height || tabbar.offsetHeight || 0);
  
          if (footerPageTop <= viewportBottom) {
            const absoluteTop = Math.max(0, Math.round(footerPageTop - barHeight));
            if (lastMode !== 'absolute' || absoluteTop !== lastTop) {
              lastMode = 'absolute';
              lastTop = absoluteTop;
              tabbar.style.position = 'absolute';
              tabbar.style.top = `${absoluteTop}px`;
              tabbar.style.bottom = 'auto';
              tabbar.style.left = '0';
              tabbar.style.right = '0';
              tabbar.style.transform = '';
            }
          } else if (lastMode !== 'fixed') {
            lastMode = 'fixed';
            lastTop = -1;
            tabbar.style.position = 'fixed';
            tabbar.style.top = 'auto';
            tabbar.style.bottom = '0';
            tabbar.style.left = '0';
            tabbar.style.right = '0';
            tabbar.style.transform = '';
          }
  
          ticking = false;
          rafId = 0;
        };
  
        const schedule = () => {
          if (ticking) return;
          ticking = true;
          rafId = window.requestAnimationFrame(updateStickyBarPosition);
        };
  
        const onResize = () => {
          footerEl = null;
          const footer = getFooterEl();
          if (footerResizeObserver && footer) {
            footerResizeObserver.disconnect();
            footerResizeObserver.observe(footer);
          }
          schedule();
        };
  
        const footer = getFooterEl();
        if (typeof ResizeObserver !== 'undefined' && footer) {
          footerResizeObserver = new ResizeObserver(() => schedule());
          footerResizeObserver.observe(footer);
        }
        if (typeof ResizeObserver !== 'undefined') {
          barResizeObserver = new ResizeObserver(() => schedule());
          barResizeObserver.observe(tabbar);
        }
  
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
  
        let onCtaClick = null;
        if (cta?.dataset?.srGleamId) {
          onCtaClick = (event) => {
            event.preventDefault();
            const popup = this.getSrGleamPopupById(cta.dataset.srGleamId);
            if (popup) {
              this.openSrGleamPopup(popup);
              return;
            }
          };
          cta.addEventListener('click', onCtaClick);
        }
  
        schedule();
        window.requestAnimationFrame(() => {
          if (!kv) setVisibleState(true);
          else updateStickyBarPosition();
        });
        this.addCleanup(() => {
          if (rafId) window.cancelAnimationFrame(rafId);
          barResizeObserver?.disconnect();
          footerResizeObserver?.disconnect();
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', onResize);
          if (onCtaClick) cta?.removeEventListener('click', onCtaClick);
          tabbar.style.position = '';
          tabbar.style.top = '';
          tabbar.style.bottom = '';
          tabbar.style.left = '';
          tabbar.style.right = '';
          tabbar.style.transform = '';
          tabbar.classList.remove('is-visible');
          delete tabbar.dataset.srTabbarDockBound;
        });
      }
  
      initEmailSubscribe() {
        this.querySelectorAll('[data-sr-subscribe]').forEach((block) => {
          this.bindEmailSubscribe(block);
        });
        const reveals = this.querySelectorAll('.sr-subscribe__reveal');
        reveals.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 1.05 && rect.bottom > 0) {
            el.classList.add('is-visible');
          }
        });
        this.observeReveal(reveals, { threshold: 0.08, rootMargin: '0px 0px 12% 0px' });
      }
  
      bindEmailSubscribe(block) {
        if (!(block instanceof HTMLElement) || block.dataset.srSubscribeBound === '1') return;
        block.dataset.srSubscribeBound = '1';
  
        const form = block.querySelector('.sr-subscribe__form');
        const input = block.querySelector('.sr-subscribe__input');
        const checkbox = block.querySelector('.sr-subscribe__checkbox');
        const messageEl = block.querySelector('.sr-subscribe__message');
        const errorEl = block.querySelector('.sr-subscribe__error');
        const submitBtn = block.querySelector('.sr-subscribe__submit');
  
        if (!(form instanceof HTMLFormElement) || !(input instanceof HTMLInputElement)) return;
  
        const formId = block.getAttribute('data-form-id') || '';
        const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
        const failText = block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
        const privacyError = block.getAttribute('data-privacy-error') || 'Please agree to the terms.';
        const emailEmptyError = block.getAttribute('data-email-empty-error') || 'Please enter your email.';
        const emailError = block.getAttribute('data-email-error') || 'Please enter a valid email address.';
        const successGleamId = block.getAttribute('data-success-gleam-id') || '';
        const configError = 'Subscription form is not configured yet.';
  
        const showError = (msg) => {
          if (errorEl) {
            errorEl.textContent = msg;
            errorEl.hidden = false;
          }
          if (messageEl) messageEl.hidden = true;
        };
  
        const showSuccess = (msg) => {
          if (messageEl) {
            messageEl.textContent = msg;
            messageEl.hidden = false;
          }
          if (errorEl) errorEl.hidden = true;
        };
  
        const clearFeedback = () => {
          if (messageEl) messageEl.hidden = true;
          if (errorEl) errorEl.hidden = true;
        };
  
        const validateEmail = (email) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            String(email).toLowerCase()
          );
  
        input.addEventListener('input', clearFeedback);
        if (checkbox instanceof HTMLInputElement) {
          checkbox.addEventListener('change', clearFeedback);
        }
  
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const emailVal = input.value.trim();
  
          if (!emailVal) {
            showError(emailEmptyError);
            return;
          }
  
          if (!validateEmail(emailVal)) {
            showError(emailError);
            return;
          }
  
          if (checkbox instanceof HTMLInputElement && !checkbox.checked) {
            showError(privacyError);
            return;
          }
  
          if (!formId) {
            showError(configError);
            return;
          }
  
          clearFeedback();
  
          if (submitBtn instanceof HTMLButtonElement) {
            if (submitBtn.disabled) return;
            submitBtn.disabled = true;
            submitBtn.classList.add('is-loading');
          }
  
          try {
            const response = await fetch('https://ecf.cirkleinc.com/api/form-submit', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: emailVal,
                accepts_marketing: checkbox instanceof HTMLInputElement && checkbox.checked ? 'on' : 'off',
                form_id: formId,
              }),
            });
  
            let data = null;
            try {
              data = await response.json();
            } catch (_) {
              showError(failText);
              return;
            }
  
            const formOk =
              response.ok &&
              data &&
              (data.status === 'success' || data.success === true || String(data.status || '').toLowerCase() === 'success');
  
            if (formOk) {
              input.value = '';
              if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
              showSuccess(successText || data.message || 'Success');
              if (successGleamId) {
                const popup = this.getSrGleamPopupById(successGleamId);
                if (popup) await this.openSrGleamPopup(popup);
              }
            } else {
              const serverMsg = data?.errors?.email?.[0] || data?.message || failText;
              showError(serverMsg);
            }
          } catch (_) {
            showError(failText);
          } finally {
            if (submitBtn instanceof HTMLButtonElement) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-loading');
            }
          }
        });
      }
  
      observeReveal(elements, options, visibleClass) {
        const className = visibleClass || 'is-visible';
        const list = elements instanceof NodeList ? Array.from(elements) : elements;
  
        if (typeof IntersectionObserver === 'undefined') {
          list.forEach((el) => el.classList.add(className));
          return;
        }
  
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add(className);
            observer.unobserve(entry.target);
          });
        }, options);
  
        list.forEach((el) => observer.observe(el));
        this.addCleanup(() => observer.disconnect());
      }
    }
  
    if (!Existing) {
      customElements.define('star-rail-series-section', StarRailSeriesSection);
    }
  })();
  